import React, { Component } from 'react';
import { connect } from 'react-redux';
import { startSetSlaves } from '../../actions/slaves';
import Statistics from '../Statistics/Statistics/Statistics';
import {parse} from "query-string";
import {correctFiltersIfInvalid} from "../Statistics/statisticsHelpers";
import {resetStatFilters, setStatisticsFilters} from "../../actions/statistics";

class MembersStatistics extends Component {
  UNSAFE_componentWillMount() {
    this.findFilters();
  }

  componentDidMount() {
    this.props.startSetSlaves();
  }

  componentWillUnmount() {
    // const { history } = this.props;
    // if (!history?.location?.pathname?.includes('statistics')) this.props.resetStatFilters();
  }

  prepareFilters = (items = {}) =>
      Object.keys(items).reduce((filters, key) => {
        if (items[key]) {
          const filter = { [key]: this.normalizeValues(items[key], key) };
          return { ...filters, ...filter };
        }

        return filters;
      }, {});

  normalizeValues = (values = '', param) => {
    if (param === 'dateFrom' || param === 'dateTo') {
      return values;
    }

    const normalized = Array.isArray(values) ? values : values.split(',').filter(String);

    return normalized.map(val => {
      if (!isNaN(val)) {
        return parseInt(val, 10);
      }

      if (param === 'countries') {
        return val.trim().toUpperCase();
      }

      return val.trim();
    });
  };

  findFilters = () => {
    const filters = parse(this.props.location.search);
    const prepared = Object.keys(filters).length > 0
      ? this.prepareFilters(correctFiltersIfInvalid(filters))
      : {};
    this.props.setStatisticsFilters({ ...prepared, type: 'webmasters' });
  };

  render() {
    const { tabProps: { showAlert } } = this.props;
    return (
      <div className='members-statistics-table'>
        <Statistics showAlert={showAlert} isMembers hideFilters />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  startSetSlaves: () => dispatch(startSetSlaves()),
  setStatisticsFilters: filters => dispatch(setStatisticsFilters(filters)),
  resetStatFilters: () => dispatch(resetStatFilters()),
});

export default connect(
  null,
  mapDispatchToProps,
)(MembersStatistics);
